import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import { serviceCatalog } from '../data/serviceCatalog';
import Button from '../Components/Button';
import ColorBtn from '../Components/ColorBtn';
import './Home.css';

function Home() {
  const { t, lang } = useLanguage();

  return (
    <div className="page-wrap">
      <section className="hero-panel">
       
      
        
            <div className="eyebrow">{t.home.eyebrow}</div>
            <h1 className="display-title">{t.home.heroTitle}</h1>
            <p className="lead">{t.home.heroText}</p>
            <div className="hero-actions">
              <ColorBtn colorBtnLink="/services" btnName={t.home.primaryCta} />
              <Button btnLink="/about" btnName={t.home.secondaryCta} />
            </div>
         

      
       
      </section>

      <section className="section">
        <div className="container">
          <div className="section-title center">
            <div className="eyebrow">Innovative Horizons</div>
            <h2>{t.home.servicesTitle}</h2>
            <p>{t.home.servicesText}</p>
          </div>

          <div className="grid-3">
            {serviceCatalog.slice(0, 6).map((service) => (
              <article className="service-card" key={service.slug}>
                <div
                  className="service-visual"
                  style={{ backgroundImage: `url(${service.image})` }}
                />
                <div className="service-body">
                  <div className="service-icon">
                    <i className={service.cName} />
                  </div>

                  <h3>{service.title[lang]}</h3>
                  <p>{service.desc[lang]}</p>

                  <ul className="check-list">
                    {service.bullets[lang].slice(0, 2).map((item) => (
                      <li key={item}>{item}</li>
                    ))}
                  </ul>

                  <Link
                    to={`/services/${service.slug}`}
                    className="nav-cta service-link-btn"
                  >
                    {t.common.seeProject}
                  </Link>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="section band">
        <div className="container split-panel">
          <div
            className="visual-block"
            style={{
              backgroundImage:
                "url('https://images.unsplash.com/photo-1451187580459-43490279c0fa?auto=format&fit=crop&w=1400&q=80')"
            }}
          >
            <div className="visual-overlay">
              <div className="eyebrow">Innovative Horizons</div>
              <h2>{t.home.processTitle}</h2>
              <p>{t.home.processText}</p>
            </div>
          </div>

          <div className="grid-3 process-stack">
            {t.home.process.map((item) => (
              <article className="feature-card" key={item.title}>
                <h3>{item.title}</h3>
                <p>{item.text}</p>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="section">
        <div className="container split-panel showcase-panel">
          <div>
            <div className="section-title">
              <div className="eyebrow">Sector focus</div>
              <h2>{t.home.showcaseTitle}</h2>
              <p>{t.home.showcaseText}</p>
            </div>

            <div className="badge-row">
              {t.home.showcaseBadges.map((item) => (
                <span className="soft-badge" key={item}>
                  {item}
                </span>
              ))}
            </div>
          </div>

          <div className="quote-box">
            <p className="body-copy quote-copy">
              Innovative Horizons puede presentar un proyecto agrícola con la misma
              elegancia que uno inmobiliario o académico, manteniendo coherencia
              visual, narrativa corporativa y una estructura clara en ambos idiomas.
            </p>

            <div className="kpi-grid">
              <div className="kpi">
                <strong>UX</strong>
                <span>Diseño limpio y explicativo</span>
              </div>
              <div className="kpi">
                <strong>Web3</strong>
                <span>Base para módulos y dApps</span>
              </div>
              <div className="kpi">
                <strong>Brand</strong>
                <span>Formalidad de empresa</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="section-tight">
        <div className="container cta-panel">
          <div className="section-title cta-title-wrap">
            <div className="eyebrow cta-eyebrow">Ready</div>
            <h2>{t.home.ctaTitle}</h2>
            <p>{t.home.ctaText}</p>
          </div>

          <div className="hero-actions cta-actions">
            <ColorBtn colorBtnLink="/contact" btnName={t.common.contactNow} />
            <Button btnLink="/portfolio" btnName={t.pages.portfolio} />
          </div>
        </div>
      </section>
    </div>
  );
}

export default Home;